import { render, staticRenderFns } from "./PageColumnItem.vue?vue&type=template&id=6196c72d&"
import script from "./PageColumnItem.vue?vue&type=script&lang=js&"
export * from "./PageColumnItem.vue?vue&type=script&lang=js&"
import style0 from "./PageColumnItem.vue?vue&type=style&index=0&id=6196c72d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports